import debounce from "lodash.debounce";
export default class LogoContrast {
    constructor(pageElement) {
        var _a;
        this.pageElement = pageElement;
        this.canvas = document.createElement("canvas");
        this.canvasContext = this.canvas.getContext("2d");
        this.logo = (_a = document.querySelector("#logo")) !== null && _a !== void 0 ? _a : document.createElement("a");
        this.run();
        window.addEventListener("resize", debounce(this.run.bind(this), 300));
    }
    run() {
        var _a, _b, _c;
        let checkedMediaElement = this.pageElement.querySelector("#article__image img");
        let checkedMediaSrc = null;
        if (checkedMediaElement) {
            checkedMediaSrc = (_a = checkedMediaElement.dataset.src) !== null && _a !== void 0 ? _a : null;
        }
        else {
            checkedMediaElement = this.pageElement.querySelector("#page-content section:first-child video");
            checkedMediaSrc = checkedMediaElement === null || checkedMediaElement === void 0 ? void 0 : checkedMediaElement.getAttribute("poster");
        }
        if (checkedMediaSrc) {
            const shadowImage = document.createElement("img");
            shadowImage.width = (_b = checkedMediaElement === null || checkedMediaElement === void 0 ? void 0 : checkedMediaElement.offsetWidth) !== null && _b !== void 0 ? _b : 10;
            shadowImage.height = (_c = checkedMediaElement === null || checkedMediaElement === void 0 ? void 0 : checkedMediaElement.offsetHeight) !== null && _c !== void 0 ? _c : 10;
            shadowImage.onload = () => {
                var _a;
                const logoAverage = this.getAverageRGB(shadowImage, this.logo);
                const logoContrast = this.setContrast(logoAverage);
                document.documentElement.style.setProperty("--logo-color", logoContrast);
                const toggleAverage = this.getAverageRGB(shadowImage, (_a = document.querySelector("#page-navigation__links .menu-toggle")) !== null && _a !== void 0 ? _a : document.createElement("button"));
                const toggleContrast = this.setContrast(toggleAverage);
                document.documentElement.style.setProperty("--toggle-color", toggleContrast);
            };
            shadowImage.setAttribute("crossOrigin", "");
            shadowImage.setAttribute("src", checkedMediaSrc);
            return true;
        }
        return false;
    }
    getAverageRGB(image, compEl) {
        // TODO Change to size on element in dom
        if (this.canvasContext) {
            this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.canvas.width = image.width;
            this.canvas.height = image.height;
            this.canvas.style.width = `${image.width}px`;
            this.canvas.style.height = `${image.height}px`;
            const { width, height, x, y, } = compEl.getBoundingClientRect();
            this.canvasContext.imageSmoothingEnabled = true;
            this.canvasContext.drawImage(image, 0, 0, image.width, image.height);
            if (width === 0 || height === 0) {
                return [0, 0, 0];
            }
            let pixelCount = 0;
            const averageRGB = { r: 0, g: 0, b: 0 };
            const imageData = this.canvasContext.getImageData(x, y, width, height);
            const dataLength = imageData.data.length;
            for (let i = 0; i < dataLength; i += 4) {
                averageRGB.r += imageData.data[i];
                averageRGB.g += imageData.data[i + 1];
                averageRGB.b += imageData.data[i + 2];
                pixelCount += 1;
            }
            return [
                Math.floor(averageRGB.r / pixelCount),
                Math.floor(averageRGB.b / pixelCount),
                Math.floor(averageRGB.g / pixelCount),
            ];
        }
        return [0, 0, 0];
    }
    setContrast(rgb = [255, 0, 0]) {
        const brightness = Math.round(((parseInt(`${rgb[0]}`, 10) * 299)
            + (parseInt(`${rgb[1]}`, 10) * 587)
            + (parseInt(`${rgb[2]}`, 10) * 114)) / 1000);
        return (brightness > 125) ? "black" : "white";
    }
}
